import { useEffect, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import ExamFinishedScreenLayout from './ExamFinishedScreenLayout';
import TrackViewAwardLink from '../../../components/TrackCard/TrackViewAwardLink';
import { useUserInfo } from '../../accounts';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Pictogram } from 'foundations-components/transitional/components/Pictogram';
import I18n from 'I18n';
import { useTrackProgress } from '../../userProgress';
import { getExamIsRecent, getProbablyHasCert } from '../examsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExamCongratulationsScreen = ({
  certificationAwardedInDifferentLanguage,
  track,
  mostRecentExamAttempt,
  pendingPracticalExercises
}) => {
  var _track$exam;
  const {
    userInfo
  } = useUserInfo();
  const examIsRecent = getExamIsRecent(mostRecentExamAttempt);
  const probablyHasCert = getProbablyHasCert(track, mostRecentExamAttempt, pendingPracticalExercises);
  const shouldPoll = certificationAwardedInDifferentLanguage ? examIsRecent : !!probablyHasCert && examIsRecent;
  const [isPolling, setIsPolling] = useState(!!shouldPoll);
  const {
    trackProgress
  } = useTrackProgress(track.id, {
    fetchPolicy: 'cache-and-network',
    polling: isPolling
  });
  const award = trackProgress === null || trackProgress === void 0 ? void 0 : trackProgress.award;
  useEffect(() => {
    if (award && !certificationAwardedInDifferentLanguage) {
      setIsPolling(false);
    }
  }, [award, certificationAwardedInDifferentLanguage]);
  const awardReadyForDifferentLanguage = certificationAwardedInDifferentLanguage ? (award === null || award === void 0 ? void 0 : award.trackIdAward) === track.id : true;
  const showTrackViewAwardLink = !certificationAwardedInDifferentLanguage || awardReadyForDifferentLanguage;
  const passDate = mostRecentExamAttempt ? mostRecentExamAttempt.attemptFinishTime : award ? award.awardedAt : undefined;
  const awardNotYetLoaded = !award && probablyHasCert && examIsRecent;
  const showLoadingSpinner = awardNotYetLoaded || !showTrackViewAwardLink;
  return /*#__PURE__*/_jsx(ExamFinishedScreenLayout, {
    callToAction: /*#__PURE__*/_jsxs(_Fragment, {
      children: [showLoadingSpinner && /*#__PURE__*/_jsx(LoadingSpinner, {
        label: I18n.text('learningCenter.exams.finished.loadingCertificate'),
        showLabel: true
      }), showTrackViewAwardLink && /*#__PURE__*/_jsx(TrackViewAwardLink, {
        award: award,
        certification: track && (track.certification || !!track.exam),
        confettiAwardedAtMs: award === null || award === void 0 ? void 0 : award.awardedAt,
        trackId: track.id,
        useCurrentText: mostRecentExamAttempt ? !mostRecentExamAttempt.passed : false
      })]
    }),
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.successHeading",
      options: {
        firstName: userInfo && userInfo.user.firstName
      }
    }),
    illustration: /*#__PURE__*/_jsx(Pictogram, {
      name: "CelebrationSuccess"
    }),
    mostRecentExamAttempt: mostRecentExamAttempt,
    pendingPracticalExercises: pendingPracticalExercises,
    prompt: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.yourScoreWas",
      options: {
        correctQuestionCount: mostRecentExamAttempt && mostRecentExamAttempt.score,
        totalQuestionCount: ((_track$exam = track.exam) === null || _track$exam === void 0 ? void 0 : _track$exam.length) || 0
      }
    }),
    showSecondaryRetakeCTA: true,
    subheading: passDate && /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.exams.finished.passedOnSubheading",
      options: {
        courseName: track && track.name,
        passDate: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "ll",
          value: passDate
        })
      }
    }),
    track: track
  });
};
export default ExamCongratulationsScreen;